import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useCancelRequestDialogStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },

  textarea: {
    width: '100%',
    marginTop: tokens.spacingVerticalXS,
    '& textarea': {
      height: '6rem !important' as unknown as string,
    },
  },

  fluidActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM,
    width: '100%',
  },

  bodyText: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    margin: '0',
  },

  confirmQuestion: {
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightSemibold,
    margin: '0',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: tokens.spacingHorizontalS,
  },

  loadingButton: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },

  charCount: {
    fontSize: fontScale.caption,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorNeutralForeground3,
    display: 'block',
    textAlign: 'right' as const,
    marginTop: tokens.spacingVerticalXXS,
  },

  errorText: {
    fontSize: fontScale.caption,
    lineHeight: tokens.lineHeightBase200,
    color: tokens.colorPaletteRedForeground1,
    margin: '0',
    marginTop: tokens.spacingVerticalXS,
  },
});
